import moment from 'moment'
import { client } from 'cogsworth/utils/ApolloClient'
import availableTimesQuery from 'graphql/queries/availableTimes'
import availableTimesUTCQuery from 'graphql/queries/availableTimesUTC'
import adHocServiceAvailableTimes from 'graphql/queries/adHocServiceAvailableTimes'
import { getDateUrlParameter } from 'cogsworth/utils/filters'

export function fetchGraphQlQuery(query, variables) {
  return client.query(query, variables)
}

export function fetchAvailableTimes({ serviceId, duration, dateFrom, dateTo, staffsIds, reschedulingId, includeDisabledStaffId, useUTCEndpoint }) {
  const variables = {
    serviceId,
    duration,
    dateFrom,
    dateTo,
    staffsIds,
    reschedulingId,
  }

  const endLimit = getDateUrlParameter(window.location.search, 'limit[end]')
  if (endLimit && variables.dateTo.isAfter(endLimit, 'day')) {
    variables.dateTo = moment(endLimit).endOf('day')
  }

  if (variables.dateFrom >= variables.dateTo) {
    return []
  }

  return client.query({
    query: useUTCEndpoint ? availableTimesUTCQuery : availableTimesQuery,
    variables,
  }).then(response => {
    return response.data.availableTimes.times
  })
}

export const availableTimesBetween = ({ availableTimes, dateFrom, dateTo }) => {
  return availableTimes.filter(slot => {
    return slot.staffs.length > 0 && slot.time >= dateFrom && slot.time <= dateTo
  })
}

export const fetchAdhocServiceAvailableTimes = ({ adHocServiceId, ignoreAppointmentId }) => {
  return client.query({
    query: adHocServiceAvailableTimes,
    variables: {
      adHocServiceId,
      ignoreAppointmentId
    },
  }).then(response => {
    return response.data.adHocServiceAvailableTimes.times
  })
}
